import React from 'react'

const OnlineGamesModule = () => {
  return (
    <>
      <div
        style={{
          width: "100%",
          height: "75vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img alt="" src="https://image.freepik.com/free-vector/coming-soon-promotion-banner-coming-soon_100456-985.jpg" />
      </div>
    </>
  )
}
export default OnlineGamesModule